import axios from 'axios';

const API_BASE_URL = process.env.API_BASE_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Function to fetch API key from localStorage
const getApiKeyFromLocalStorage = () => {
  return localStorage.getItem('apiKey');
};

// Interceptor to modify the request payload to include API key
api.interceptors.request.use((config) => {
  const apiKey = getApiKeyFromLocalStorage();
  if (!apiKey) {
    console.error("API key not found in localStorage");
    throw new Error("API key not found");
  }
  config.data = {
    ...config.data,
    api_key: apiKey,
  };
  return config;
});

export default api;
